/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForInboundPictureParcelInfoVo } from './OrderInfoForInboundPictureParcelInfoVo';
import {
    OrderInfoForInboundPictureParcelInfoVoFromJSON,
    OrderInfoForInboundPictureParcelInfoVoFromJSONTyped,
    OrderInfoForInboundPictureParcelInfoVoToJSON,
    OrderInfoForInboundPictureParcelInfoVoToJSONTyped,
} from './OrderInfoForInboundPictureParcelInfoVo';

/**
 * 
 * @export
 * @interface OrderInfoVo1
 */
export interface OrderInfoVo1 {
    /**
     * 订单id
     * @type {number}
     * @memberof OrderInfoVo1
     */
    orderId?: number;
    /**
     * 订单号
     * @type {string}
     * @memberof OrderInfoVo1
     */
    orderCode?: string;
    /**
     * 区域
     * @type {string}
     * @memberof OrderInfoVo1
     */
    zone?: string;
    /**
     * 库位
     * @type {string}
     * @memberof OrderInfoVo1
     */
    location?: string;
    /**
     * 附加服务
     * @type {string}
     * @memberof OrderInfoVo1
     */
    additionalService?: string;
    /**
     * 备注
     * @type {string}
     * @memberof OrderInfoVo1
     */
    remark?: string;
    /**
     * 仓库备注
     * @type {string}
     * @memberof OrderInfoVo1
     */
    warehouseRemarkCn?: string;
    /**
     * 仓库备注
     * @type {string}
     * @memberof OrderInfoVo1
     */
    warehouseRemarkKr?: string;
    /**
     * 所有快递单号
     * @type {Array<OrderInfoForInboundPictureParcelInfoVo>}
     * @memberof OrderInfoVo1
     */
    allParcelTrackingNumber?: Array<OrderInfoForInboundPictureParcelInfoVo>;
    /**
     * 接收人配送要求
     * @type {string}
     * @memberof OrderInfoVo1
     */
    receiverDeliveryRequirement?: string;
}

/**
 * Check if a given object implements the OrderInfoVo1 interface.
 */
export function instanceOfOrderInfoVo1(value: object): value is OrderInfoVo1 {
    return true;
}

export function OrderInfoVo1FromJSON(json: any): OrderInfoVo1 {
    return OrderInfoVo1FromJSONTyped(json, false);
}

export function OrderInfoVo1FromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoVo1 {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'zone': json['zone'] == null ? undefined : json['zone'],
        'location': json['location'] == null ? undefined : json['location'],
        'additionalService': json['additionalService'] == null ? undefined : json['additionalService'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'warehouseRemarkCn': json['warehouseRemarkCn'] == null ? undefined : json['warehouseRemarkCn'],
        'warehouseRemarkKr': json['warehouseRemarkKr'] == null ? undefined : json['warehouseRemarkKr'],
        'allParcelTrackingNumber': json['allParcelTrackingNumber'] == null ? undefined : ((json['allParcelTrackingNumber'] as Array<any>).map(OrderInfoForInboundPictureParcelInfoVoFromJSON)),
        'receiverDeliveryRequirement': json['receiverDeliveryRequirement'] == null ? undefined : json['receiverDeliveryRequirement'],
    };
}

export function OrderInfoVo1ToJSON(json: any): OrderInfoVo1 {
    return OrderInfoVo1ToJSONTyped(json, false);
}

export function OrderInfoVo1ToJSONTyped(value?: OrderInfoVo1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'zone': value['zone'],
        'location': value['location'],
        'additionalService': value['additionalService'],
        'remark': value['remark'],
        'warehouseRemarkCn': value['warehouseRemarkCn'],
        'warehouseRemarkKr': value['warehouseRemarkKr'],
        'allParcelTrackingNumber': value['allParcelTrackingNumber'] == null ? undefined : ((value['allParcelTrackingNumber'] as Array<any>).map(OrderInfoForInboundPictureParcelInfoVoToJSON)),
        'receiverDeliveryRequirement': value['receiverDeliveryRequirement'],
    };
}

